export const environment = {
    production: true,
    VERSION : "29280"
};